var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodata-state-container ml-4 mr-4 animate-simple"},[_c('span',{staticClass:"nodata-state icon sli-puzzle"}),_vm._v(" "),_c('span',{staticClass:"nodata-state-caption"},[_vm._v(_vm._s(_vm.$t("global.no_data")))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-494ced93","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoData.vue
// module id = null
// module chunks = 